import React from 'react';
import { Formik } from 'formik';
import { InputControl } from 'modules/shared-form';
import { ClassicButton, PageTitle } from 'modules/shared-ui/components';

import { AccessAppointmentFormProps, AppointmentAccess } from './access-appointment-form-type';

import styles from './access-appointment-form-component.module.css';

export const AccessAppointmentForm: React.FC<AccessAppointmentFormProps> = ({
    model,
    onSuccess,
}: AccessAppointmentFormProps) => {
    return (
        <React.Fragment>
            <Formik<AppointmentAccess>
                initialValues={model}
                onSubmit={onSuccess}
                render={props => (
                    <form className={styles.formContainer}>
                        <PageTitle title="VOUS AVEZ VOTRE RÉFÉRENCE" uppercase centered />

                        <div className={styles.fieldsContainer}>
                            <div className={styles.label}>Référence du rendez-vous</div>
                            <InputControl name="reference" />
                        </div>

                        <div className={styles.buttonsContainer}>
                            <ClassicButton
                                text="ACCÉDER A VOTRE RENDEZ-VOUS"
                                onClick={props.submitForm}
                                disabled={!props.isValid}
                            />
                        </div>
                    </form>
                )}
            />
        </React.Fragment>
    );
};
